export default __webpack_public_path__ + "paddle_internet_hover339f94.svg";